import { z } from 'zod';

// The usage watch (throwaway: backend/src/modules/usage/README.md).

export const UsageViewRequest = z.strictObject({
  path: z.string().min(1).max(500),
  title: z.string().max(200).optional(),
  ms: z.number().int().min(0).max(86_400_000).optional(),
});
export type UsageViewRequest = z.input<typeof UsageViewRequest>;

export const UsageDaysQuery = z.strictObject({
  days: z.coerce.number().int().min(1).max(90).optional(),
});
export type UsageDaysQuery = z.input<typeof UsageDaysQuery>;

export const UsageOperatorParams = z.strictObject({ adminId: z.guid() });

export const UsageDriveScanRequest = z.strictObject({
  root: z.string().max(500).optional(),
  files: z
    .array(
      z.strictObject({
        path: z.string().min(1).max(1000),
        modifiedAt: z.iso.datetime({ offset: true }),
        size: z.number().int().min(0).nullable().optional(),
        modifiedBy: z.string().max(200).nullable().optional(),
      }),
    )
    .max(5000),
});
export type UsageDriveScanRequest = z.input<typeof UsageDriveScanRequest>;

export const UsageDriveState = z.enum(['open', 'imported', 'ignored']);

export const UsageDriveListQuery = z.strictObject({
  state: z.union([UsageDriveState, z.literal('all')]).optional(),
  days: z.coerce.number().int().min(1).max(3650).optional(),
});

export const UsageDriveIdParams = z.strictObject({ id: z.string().regex(/^\d{1,18}$/) });

export const UsageDriveDecisionRequest = z.strictObject({
  state: UsageDriveState,
  note: z.string().max(500).optional(),
});
export type UsageDriveDecisionRequest = z.input<typeof UsageDriveDecisionRequest>;
